export const HAS_ACCOUNT_COOKIE = 'wt_has_account';

export function getAppUrl() {
  const configured = (
    process.env.REACT_APP_APP_URL || process.env.REACP_APP_APP_URL || 'https://app.whoppatix.com'
  ).trim().replace(/^["']|["']$/g, '').replace(/\/+$/, '');
  try {
    const url = new URL(configured);
    return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? configured : '';
  } catch { return ''; }
}

export function hasAccountCookie() {
  try {
    return document.cookie
      .split(';')
      .some((entry) => entry.trim().startsWith(`${HAS_ACCOUNT_COOKIE}=`));
  } catch {
    return false;
  }
}

export async function fetchAuthenticated() {
  const appUrl = getAppUrl();

  try {
    const response = await fetch(`${appUrl}/api/marketing/auth-status`, {
      method: 'GET',
      credentials: 'include',
      cache: 'no-store',
    });

    if (!response.ok) {
      return false;
    }

    const data = await response.json();
    return Boolean(data.authenticated);
  } catch {
    return false;
  }
}

export function resolveMarketingAuthState(authenticated, hasAccount) {
  if (authenticated) {
    return 'authenticated';
  }

  if (hasAccount) {
    return 'returning';
  }

  return 'guest';
}

export function getInitialMarketingAuthState() {
  return hasAccountCookie() ? 'returning' : 'guest';
}

export function getPrimaryCta(state) {
  const appUrl = getAppUrl();

  switch (state) {
    case 'authenticated':
      return { href: `${appUrl}/`, label: 'Open app' };
    case 'returning':
      return { href: `${appUrl}/sign-in`, label: 'Log in' };
    default:
      return { href: `${appUrl}/sign-up`, label: 'Get started' };
  }
}

export function getSignupCta(state) {
  const appUrl = getAppUrl();

  switch (state) {
    case 'authenticated':
      return { href: `${appUrl}/`, label: 'Open app' };
    case 'returning':
      return { href: `${appUrl}/sign-in`, label: 'Log in' };
    default:
      return { href: `${appUrl}/sign-up`, label: 'Sign up' };
  }
}

export function getNavbarActions(state) {
  const appUrl = getAppUrl();

  switch (state) {
    case 'authenticated':
      return {
        primary: { href: `${appUrl}/`, label: 'Open app' },
        secondary: null,
      };
    case 'returning':
      return {
        primary: { href: `${appUrl}/sign-in`, label: 'Log in' },
        secondary: { href: `${appUrl}/sign-up`, label: 'Sign up' },
      };
    default:
      return {
        primary: { href: `${appUrl}/sign-up`, label: 'Sign up' },
        secondary: { href: `${appUrl}/sign-in`, label: 'Log in' },
      };
  }
}

export function getCtaSubtitle(state) {
  switch (state) {
    case 'authenticated':
      return 'You are signed in — jump back into your dashboard.';
    case 'returning':
      return 'Welcome back — pick up where you left off.';
    default:
      return 'Create an account, build your event draft, then complete payment setup when you are ready to sell.';
  }
}
